import { Box, Typography, useTheme } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../layout/AuthLayout/Footer";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";

export default function GuidePage() {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            onClick={() => navigate("/")}
            sx={{
              cursor: "pointer",
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            sx={{
              color: "secondary.main",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            راهنما بازارگاه
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          gap: "12px",
        }}
      >
        <Outlet />
      </Box>
      <AuthFooter />
    </>
  );
}
